import { Card, Skeleton, Typography } from 'antd';
import { useState, useEffect } from 'react';

import styles from './Description.module.css';

const { Paragraph } = Typography;

const Description = (props) => {
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [activeTabKey, setActiveTabKey] = useState('pt');

  const tabList = [
    {
      key: 'pt',
      tab: 'PT',
    },
    {
      key: 'en',
      tab: 'EN',
    },
  ];

  const onLgTabChange = (key) => {
    setActiveTabKey(key);
    getDescriptionLg(key);
  };

  const getDescriptionLg = (lg) => {
    let keywordToSearch = lg === tabList[0].key ? props.label : props.customWikiEn;
    keywordToSearch = keywordToSearch === 'Vitamina E' ? 'Tocoferol' : keywordToSearch;
    fetch(
      `https://${lg}.wikipedia.org/w/api.php?format=json&action=query&origin=*&prop=extracts&indexpageids&exintro=1&explaintext=1&titles=${keywordToSearch}`,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        setDescription(responseJson.query.pages[responseJson.query.pageids[0]].extract);
        setIsLoading(false);
      });
  };

  //https://pt.wikipedia.org/w/api.php?format=json&action=query&prop=extracts&exintro=1&explaintext=1&titles=C%C3%A1lcio
  useEffect(() => {
    getDescriptionLg('pt');
  }, []);

  if (description && description.length > 0 && isLoading) {
    setIsLoading(false);
  }

  return (
    <Card
      style={props.style}
      className={styles.description}
      tabList={tabList}
      //tabBarExtraContent={<span style={{ color: 'blue' }}>Fonte: Wikipedia</span>}
      activeTabKey={activeTabKey}
      onTabChange={onLgTabChange}>
      {isLoading ? (
        <Skeleton></Skeleton>
      ) : (
        <Paragraph style={props.style} className={styles.justify} ellipsis={{ rows: 13, expandable: true, symbol: 'Ler mais...' }}>
          {' '}
          {description}
        </Paragraph>
      )}
    </Card>
  );
};

export default Description;
